
import AdminLayout from "@/components/admin/AdminLayout";
import AdvancedReportGenerator from "@/components/admin/reporting/AdvancedReportGenerator";
import { FileText } from "lucide-react";

const AdminReporting = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="flex items-center space-x-3">
          <FileText className="h-8 w-8 text-blue-600" />
          <div>
            <h1 className="text-3xl font-bold text-foreground">Advanced Reporting</h1>
            <p className="text-muted-foreground mt-1">
              Generate comprehensive business reports with AI insights and analytics
            </p>
          </div>
        </div>

        <AdvancedReportGenerator />
      </div>
    </AdminLayout>
  );
};

export default AdminReporting;
